import { gql } from "graphql-tag";
import { basePageableGraphqlField, responseField } from "../../../base.graphql";
import { StoreItemFiltering } from "../../store-item/store-item.model";
import { zonesBinsMappingFields } from "../bin/bin.graphql";

// Define fields for device
export const deviceFields = `
            id
            uniqueId
            sensorName
            serialNumber
            sensorType
            sensorIp
            sensorLocation
            isColdRoomSensor
            posPicture
        `;
export const sensorByBinFields = `
id
sensorUniqueId
sensorIp
serialNumber
coveredBins {
    id
    uniqueId
    binNumber
    isActive
}
`

export const zoneBinMapping = `
id
uniqueId
binNumber
zone
createdDate
isActive`
// Queries

export const GET_ALL_SENSORS = gql`
query GetAllSensors ($filtering:WarehouseSensorFilteringObject) {
  getAllSensors(filtering: $filtering) {
      response {
         ${responseField}
      }
      page {
         ${basePageableGraphqlField}
      }
      data {
         ${deviceFields}
      }
  }
}
`;

export const GET_DEVICE_DATA = gql`
query GetAllDevice($filtering: SensorFilteringInputObject) {
    getAllDevice(filtering:$filtering) {
        response {
            ${responseField}
        }
        page {
            ${basePageableGraphqlField}
        }
        data {
          ${deviceFields}
        }
    }
}
`;

export const GET_DEVICE_READINGS_DATA = gql`
  query getDeviceReadingsData($filtering: DeviceReadingsDataFilteringObject) {
    getDeviceReadingsData(filtering: $filtering) {
      response {
        ${responseField}
      }
      data {
        ${deviceFields}
      }
    }
  }`;

export const GET_DEVICE_READINGS_DATA_DASHBOARD = gql`
  query getDeviceReadingsDashboard($filtering: DeviceReadingsDashBoardFilteringObject) {
      getDeviceReadingsDashboard(filtering: $filtering) {
      response {
        ${responseField}
      }
          data {
              averageHumidity
              averageTemperarture
              highestHumidity
              highestTemperature
              lowestHumidity
              lowestTemperature
              readingData {
                  humidity
                  readingIsCurrent
                  temperature
                  timeStamp
                  uniqueId
                  id
              }
          }
    }
  }`;

// Mutations

export const DELETE_WAREHOUSE_SENSOR_MUTATION = gql`mutation DeleteWarehouseSensorsMutation($uniqueId:String!){
  deleteWarehouseSensorsMutation(uniqueId:$uniqueId) {
      response {
        ${responseField}
      }
  }
}
`;

export const CREATE_WAREHOUSE_SENSOR_MUTATION = gql`mutation CreateWarehouseSensorsMutation($input: WarehouseSensorInputObject!) {
  createWarehouseSensorsMutation(input: $input) {
      data {
          ${deviceFields}
      }
      response {
          ${responseField}
      }
  }
}
`;
export const UPDATE_WAREHOUSE_SENSOR_MUTATION = gql`mutation UpdateWarehouseSensorsMutation($input: WarehouseSensorInputObject!) {
  updateWarehouseSensorsMutation(input: $input) {
      data {
          ${deviceFields}
      }
      response {
          ${responseField}
      }
  }
}
`;

export const REGISTER_DEVICE_MUTATION = gql`
 mutation RegisterDeviceMutation ($input: SensorInputObject!){
    registerDeviceMutation(input:$input){
        response {
            ${responseField}
        }
        data {
          ${deviceFields}
        }
    }
}
`;

export const CREATE_ZONE_BIN_MAPPING = gql`
    mutation CreateZonesBinsMapping($input: ZonesBinsMappingInput!) {
        createZonesBinsMapping(input: $input) {
            response {
                ${responseField}
            }
            data {
                ${zoneBinMapping}
            }
        }
    }
`

export const UPDATE_DEVICE_MUTATION = gql`
    mutation UpdateDeviceMutation($input: SensorInputObject!) {
    updateDeviceMutation(input: $input) {
        response {
           ${responseField}
        }
        data {
            ${deviceFields}
        }
    }
}
`;

export const DELETE_DEVICE_MUTATION = gql`
  mutation DeleteDeviceMutation ($uniqueId:String!){
    deleteDeviceMutation(uniqueId: $uniqueId) {
        response {
         ${responseField}
        }
    }
}
`;

export const DELETE_DEVICE_READINGS_DATA = gql`
  mutation deleteDeviceReadingsData($uniqueId: String) {
    deleteDeviceReadingsData(uniqueId: $uniqueId) {
      response {
        ${responseField}
      }
    }
  }`;

/**
 * Sensor Bin Coverage
 */

export const GET_SENSOR_BIN_COVERAGE = gql`query GetSensorBinCoverage ($filtering: SensorBinCoverageFilteringObject){
  getSensorBinCoverage(filtering: $filtering) {
    data {
         ${sensorByBinFields}
      }
      page {
         ${basePageableGraphqlField}
      }
      response {
         ${responseField}
      }
  }
}
`;

export const UPDATE_SENSOR_BIN_COVERAGE = gql`mutation UpdateSensorBinCoverageMutation($input: SensorBinCoverageInputObject!) {
  updateSensorBinCoverageMutation(input: $input) {
      response {${responseField}}
      data {
       ${sensorByBinFields}
      }
  }
}
`;

export const CREATE_SENSOR_BIN_COVERAGE = gql`mutation CreateSensorBinCoverageMutation($input: SensorBinCoverageInputObject!) {
  createSensorBinCoverageMutation(input: $input) {
      response {
          id
          status
          code
          message
      }
      data {
       ${sensorByBinFields}
      }
  }
}
`

export const GET_SENSOR_STATUS = gql`query GetSensorsStatus($filtering: DrillDownFilteringInputObject) {
  getSensorsStatus(filtering: $filtering) {
      response {
          id
          status
          code
          message
      }
      data {
          dashboardData
      }
      page {
          number
          hasNextPage
          hasPreviousPage
          currentPageNumber
          nextPageNumber
          previousPageNumber
          numberOfPages
          totalElements
          pagesNumberArray
      }
  }
}
`
export const GET_SENSOR_LIVE_STATUS = gql`query GetSensorsWithLiveStatus($filtering:DrillDownFilteringInputObject) {
    getSensorsWithLiveStatus(filtering: $filtering) {
        data {
            dashboardData
        }
        page {
            number
            hasNextPage
            hasPreviousPage
            currentPageNumber
            nextPageNumber
            previousPageNumber
            numberOfPages
            totalElements
            pagesNumberArray
        }
        response {
            id
            status
            code
            message
        }
    }
}
`
export const GET_SENSOR_REALTIME_DATA = gql`query GetSensorRealTimeReadings($filtering:DrillDownFilteringInputObject) {
  getSensorRealTimeReadings(filtering:$filtering) {
      response {
          id
          status
          code
          message
      }
      data {
          dashboardData
      }
      page {
          number
          hasNextPage
          hasPreviousPage
          currentPageNumber
          nextPageNumber
          previousPageNumber
          numberOfPages
          totalElements
          pagesNumberArray
      }
  }
}
`
